import template from './employee-create.html';
import controller from './employee-create.controller';

let employeeCreateComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default employeeCreateComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/employee-create/employee-create.component.js